import { autoCapitalize } from '@/utils/autoCapitalize'
import { format } from 'date-fns'
import {
  HistoryAppointmentData,
  HistoryAppointmentParamsMapper,
} from './HistoryAppointmentListMapper.types'

class HistoryAppointmentListMapper {
  toDomain(persistenceData: HistoryAppointmentData) {
    return {
      id: persistenceData?.id,
      status: autoCapitalize(persistenceData?.status),
      token: persistenceData?.token,
      hasDocument: persistenceData?.possuiDocumentos,
      unifiedClinic: persistenceData?.clinicaUnificada,
      clinic: {
        id: persistenceData?.clinica?.id,
        name: autoCapitalize(persistenceData?.clinica?.nome),
      },
      patient: {
        id: persistenceData?.paciente?.id,
        name: autoCapitalize(persistenceData?.paciente?.nome),
      },
      responsibleProfessional: {
        id: persistenceData?.profissionalResponsavel?.id,
        fullName: autoCapitalize(
          persistenceData?.profissionalResponsavel?.nomeCompleto,
        ),
      },
      specialty: autoCapitalize(persistenceData?.especialidade) || '-',
      appointmentDate: persistenceData?.dataAtendimentoFmt,
      isConfirmed: persistenceData?.statusConfirmacao ? 'Sim' : 'Não',
    }
  }

  toPersistence(domainData: HistoryAppointmentParamsMapper) {
    if (domainData?.appointmentId)
      return {
        page: domainData?.page,
        itemsPerPage: domainData?.itemsPerPage,
        idAtendimento: Number(domainData?.appointmentId),
      }

    const initialDateFormatted = format(
      new Date(domainData?.initialDate),
      'dd/MM/yyyy 00:00:00',
    )

    const finalDateFormatted = format(
      new Date(domainData?.finalDate),
      'dd/MM/yyyy 23:59:59',
    )

    return {
      clinica: { id: domainData?.clinic?.id || null },
      cpf: domainData?.cpf || null,
      dataInicio: initialDateFormatted,
      dataFim: finalDateFormatted,
      email: domainData?.email || null,
      nome: domainData?.name || null,
      perfil: domainData?.profile?.key,
      tipoProfissional: domainData?.professionalType?.key || null,
      page: domainData?.page,
      itemsPerPage: domainData?.itemsPerPage,
    }
  }
}

export default new HistoryAppointmentListMapper()
